// UserService.js
import axios from "axios";
import { USER_SERVICE_URL } from '../apiConfig';

const authHeader = () => {
  try {
    const user = localStorage.getItem("user");
    const parsedUser = user ? JSON.parse(user) : null;
    const token = parsedUser && parsedUser.token ? parsedUser.token : null;

    return token ? { "x-access-token": token } : {};
  } catch (_error) {
    return {};
  }
};

const getPublicContent = () => {
  return axios.get(USER_SERVICE_URL + "all");
};

const getUserBoard = () => {
  return axios.get(USER_SERVICE_URL + "user", { headers: authHeader() });
};

const getModeratorBoard = () => {
  return axios.get(USER_SERVICE_URL + "mod", { headers: authHeader() });
};

const getAdminBoard = () => {
  return axios.get(USER_SERVICE_URL + "admin", { headers: authHeader() });
};

const UserService = {
  getPublicContent,
  getUserBoard,
  getModeratorBoard,
  getAdminBoard,
};

export default UserService;
